import Vue from 'vue'
import { BVConfigPlugin, ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'



// import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'
import Tables from '@core/table'
import VueProgress from 'vue-progress-path'
// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'
import '@/libs/ripple'

// Axios Mock Adapter
// import '@/@fake-db/db'
Vue.use(require('vue-moment'));

// BSV Plugin Registration

Vue.use(BVConfigPlugin, {
  BFormDatepicker: { dateFormatOptions: { year: 'numeric', month: 'numeric', day: 'numeric' } },
})

Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

Vue.use(VueProgress)
Vue.use(Tables);

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
// require('@core/scss/core.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  // i18n,
  render: h => h(App),
}).$mount('#app')
